import React, { useState, useEffect } from "react";

const AdminIdli = () => {
  const mobNum = localStorage.getItem("moblie");

  var [tit, setTit] = useState("");
  var [firstName, setFirstName] = useState("");
  var [middleName, setMiddleName] = useState("");
  var [lastName, setLastName] = useState("");
  var [fatherName, setFatherName] = useState("");
  var [aadhaarNo, setAadhaarNo] = useState("");
  var [mobileNo, setMobileNo] = useState("");
  var [panNo, setPanNo] = useState("");
  var [email, setEmail] = useState("");
  var [gender, setGender] = useState("");
  var [dob, setDob] = useState("");
  var [addressUser, setAddressUser] = useState("");
   var [property, setProperty] = useState("");

  return (
    <>
      <div className="row justify-content-around ">
        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              Title:
            </label>
            <select
              className="form-control form-select"
              onChange={(e) => setTit(e.target.value)}
            >
              <option value="">Select Title</option>
              <option value="Mr">Mr</option>
              <option value="Mrs">Mrs</option>
            </select>
            {/* <input
                  type="mobile"
                  id="aadhaarcard"
                  className="form-control"
                  placeholder="Enter here"
                /> */}
          </div>
        </div>
        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
               Name Of Applicant:
            </label>
            <input
              type="mobile"
              id="aadhaarcard"
              onChange={(e) => setFirstName(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>
       
        <div className="col-4">
              <div className="form-outline mb-3 ">
                <label className="form-label" for="id">
                  Father Name:
                </label>
                <input
                  type="mobile"
                  onChange={(e) => setFatherName(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>
       
      
        <div className="col-4">
              <div className="form-outline mb-3 ">
                <label className="form-label" for="id">
                  Type of property:
                </label>
                <input
                  type="mobile"
                  onChange={(e) => setProperty(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>
           

        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              Mobile Number:
            </label>
            <input
              type="mobile"
              // onChange={(e) => setMobileNo(e.target.value)}
              value={mobNum}
              disabled
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>

        <div className="col-4">
          <div className="form-outline mb-3 ">
            <label className="form-label" for="id">
              Aadhaar Number:
            </label>
            <input
              type="mobile"
              //   onChange={(e) => setAadhaarNo(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>

        <div className="col-4">
              <div className="form-outline mb-3 ">
                <label className="form-label" for="id">
                  Email:
                </label>
                <input
                  type="mobile"
                //   onChange={(e) => setEmail(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>
            <div className="col-4">
              <div className="form-outline mb-3 ">
                <label className="form-label" for="id">
                  Branch:
                </label>
                <input
                  type="mobile"
                //   onChange={(e) => setEmail(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>
           
            <div className="col-4">
              <div className="form-outline mb-3">
                <label className="form-label" for="id">
                  Address:
                </label>
                <input
                  type="mobile"
                  onChange={(e) => setAddressUser(e.target.value)}
                  className="form-control"
                  placeholder="write your full address here"
                />
              </div>
            </div>

      </div>
    </>
  );
};
export default AdminIdli;
